import { cacheKeys } from "@constants/cache-keys";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useQuery } from "@tanstack/react-query";
import { getMixedItemDistribution } from "api/queries";
import type { MixedItemDistAction } from "./types";
import useAuthUser from "./useAuthUser";

const useMixedItemDist = (enabled = true, action?: MixedItemDistAction) => {
	const {
		currentExamContext: { examId, studyPackCollectionId },
	} = useExamContext();
	const { userPublicMetadataId } = useAuthUser();

	const finalAction = action ?? "COMMON_DISTRIBUTION";

	const queryKey = [
		cacheKeys.home,
		userPublicMetadataId,
		finalAction,
		examId,
		...(studyPackCollectionId ? [studyPackCollectionId] : []),
	];

	const result = useQuery({
		queryKey,
		queryFn: async () =>
			await getMixedItemDistribution({
				userPublicMetadataId: userPublicMetadataId!,
				action: finalAction,
				examId: examId!,
				collectionId: studyPackCollectionId!,
			}),
		enabled: !!userPublicMetadataId && enabled && !!examId,
	});
	return {
		...result,
		data: result.data,
	};
};

export default useMixedItemDist;
